"use strict";

import Swiper from "swiper";
import { EffectFade, Autoplay, Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".timesofday").forEach((section) => {
        const slider = section.querySelector(".timesofday-slider");
        const liItems = section.querySelectorAll(".list-bottom ul li");

        if (!slider || liItems.length === 0) return;

        const swiper = new Swiper(slider, {
            modules: [EffectFade, Autoplay, Navigation, Pagination],
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            loop: false,
            speed: 1000,
            on: {
                init: function () {
                    updateCustomPagination(this.realIndex, liItems);
                },
                slideChange: function () {
                    updateCustomPagination(this.realIndex, liItems);
                }
            }
        });
        liItems.forEach((li, index) => {
            li.style.cursor = "pointer";
            li.addEventListener("click", () => {
                swiper.slideToLoop(index);
            });
        });
    });
});

function updateCustomPagination(realIndex, liItems) {
    liItems.forEach(li => li.classList.remove("active"));
    if (liItems[realIndex]) {
        liItems[realIndex].classList.add("active");
    }
}

